import React, {useCallback, useMemo, useState, useEffect} from "react";
import useFetch from "@common/hooks/fetch/useFetch";
import {getJobList} from "@common/services/restapi/job";
import Empty from "../../assets/image/empty.png";
import {LazyLoadImage} from 'react-lazy-load-image-component';
import Page from "@common/enums/Page.enums";
import InterSectionObserver from '@common/components/intersection/InterSectionObserver';
import {convertPath} from "@common/utils/path/linkPath";
import {useParams} from "react-router-dom";

function JobList() {
  const [page, setPage] = useState(Page.page.defaultPage);
  const {category = 'employee'} = useParams();
  const [jobSearchList, setJobSearchList] = useState([]);
  const [jobListTotalCount, setJobListTotalCount] = useState(0);

  const searchQuery = useMemo(() => {
    return {
      category: category,
      pageNumber: page,
      pageSize: Page.size.defaultSize,
    }
  },[category, page]);

  const {data, loading:dataLoading} = useFetch(() => getJobList(searchQuery),[searchQuery], {});

  useEffect(() => {
    const {jobList = [], pageInfo = {}} = data;
    const {totalCount = 0} = pageInfo;
    if (jobList?.length) {
      setJobSearchList(jobSearchList.concat(data.jobList));
    }
    if (totalCount) {
      setJobListTotalCount(totalCount);
    }
  },[data]);

  const handleObserver = useCallback(() => {
    setPage(page + 1);
  },[page]);

  return (
    <>
      <div className="common-header--top">
        <h3 className="header-title">채용정보</h3>
      </div>

      <section className="common-body--list">
        <div className="job-list">
          {jobSearchList.map((job, index) => {
            return (
              <a href={convertPath(`/job/employee/${job.ukey}`)} className="thumbnail-card job" key={`job-${index}`}>
                <LazyLoadImage className="left-box"
                               src={`${job.thumbnail.includes('null') ? `${Empty}` : `${job.thumbnail.replace("http:", "https:")}`}`}/>
                <div className="right-box">
                  <h4 className="title">{job.title}</h4>
                  <div className="company">{job.corpName}</div>
                  <p className="welfare">{job.description}</p>
                  <div className="career">
                    {job.experienceLevel === 0 ? '무관' : job.experienceLevel === 1 ? '신입' : job.experienceLevel === 2 ? "경력 1년이상" : job.experienceLevel === 3 ? "경력 2년이상" : job.experienceLevel === 4 ? '경력 3년이상' : job.experienceLevel === 5 ? '경력 4년이상' : job.experienceLevel === 6 ? '경력 5년이상' : job.experienceLevel === 7 ? ' 경력 6년이상' : job.experienceLevel === 8 ? ' 경력 7년이상' : job.experienceLevel === 9 ? '경력 8년이상' : job.experienceLevel === 10 ? '경력 9년이상' : '경력 10년이상'}
                  </div>
                </div>
              </a>
            )
          })}
        </div>
        {
          !dataLoading && jobListTotalCount > jobSearchList.length &&
          <InterSectionObserver dataLoading={dataLoading} onHandleObserver={handleObserver} />
        }
      </section>
    </>
  )
}

export default JobList;
